import React from 'react';
import PropTypes from 'prop-types';
import {addPopup, removePopup} from 'spa/lib/popup';
import ReactDOM from 'react-dom';

export default class Popup extends React.Component {
  static propTypes = {
    children: PropTypes.element.isRequired,
    doNotAddNoScroll: PropTypes.bool,
    greenMode: PropTypes.bool,
  };

  static defaultProps = {
    doNotAddNoScroll: false,
  }

  componentDidMount() {
    const {greenMode} = this.props;

    this.popup = addPopup(undefined, this.props.doNotAddNoScroll, greenMode);
    ReactDOM.unstable_renderSubtreeIntoContainer(this, this.props.children, this.popup.subContainer);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.children !== this.props.children) {
      ReactDOM.unstable_renderSubtreeIntoContainer(this, nextProps.children, this.popup.subContainer);
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    removePopup(this.popup);
  }

  render() {
    return (
      null
    );
  }
}



// WEBPACK FOOTER //
// ./spa/Components/Popup.jsx